// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-school-crm/src/models/dataStatistics';
import model_2 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-school-crm/src/models/dictionary';
import model_3 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-school-crm/src/models/global';
import model_4 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-school-crm/src/models/importModal';
import model_5 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-school-crm/src/models/leads';
import model_6 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-school-crm/src/models/login';
import model_7 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-school-crm/src/models/survey';

export const models = {
model_1: { namespace: 'dataStatistics', model: model_1 },
model_2: { namespace: 'dictionary', model: model_2 },
model_3: { namespace: 'global', model: model_3 },
model_4: { namespace: 'importModal', model: model_4 },
model_5: { namespace: 'leads', model: model_5 },
model_6: { namespace: 'login', model: model_6 },
model_7: { namespace: 'survey', model: model_7 },
} as const
